<template>
  <div class="cv-content" id="pdfDom" v-if="cv.format_info"
       :class="`padding-${formatInfo.page_margin} lineH-${formatInfo.line_spacing} fontsize-${formatInfo.font_size} ${formatInfo.font} ${formatInfo.top_format==='line' ? 'line-header': ''}`"
       :style="cvContentStyle">
    <div class="resume-editor" ref="resumeEditor" id="resumeEditor" style="height: auto">
      <div class="profile resume-editor-header flex-between" :class="[formatInfo.head_format === 'body_center'?'body_center':'']">
        <div class="profile-left" v-if="formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center'" :style="!basicInfo.school_logo_url ? `width: 110px` : ''">
          <img :src="basicInfo.school_logo_url" alt="" class="logo-url">
        </div>
        <div class="flex">
          <div class="profile-left-avatar"
               v-if="formatInfo.head_format === 'left' && profiles.avatar_url && basicInfo.school_logo_url">
            <img :src="profiles.avatar_url && basicInfo.school_logo_url ? profiles.avatar_url : ''" alt="">
          </div>
          <div class="profile-middle" v-if="profileShow"
               :class="[formatInfo.head_format === 'left' ? 'profile-middle-left' : 'profile-middle-center']">
            <p class="name editor-header-title">{{profiles.username | hideMessageFormat(hideProfile)}}</p>
            <div class="profile-content" :class="[profiles.show_attr_name===2 ? 'show-profile-icon' : '']">
              <p class="editor-sub-header-title"
                 :class="[formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center' ? 'flex-center' : 'flex-start']">
                <span v-if="profiles.phone"><i class="profile-icon iconfont icondianhua2"></i>{{showName(profiles.phone, '电话', 'Phone') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.email"><i class="profile-icon iconfont iconyouxiang2"></i>{{showName(profiles.email, '邮箱', 'Email') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.address"
                      class="not-delimiter"><i class="profile-icon iconfont iconxianjuchengshi"></i>{{showName(profiles.address, '现居城市', 'Address') | hideMessageFormat(hideProfile)}}</span>
              </p>
              <p class="editor-sub-header-title"
                 :class="[formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center' ? 'flex-center' : 'flex-start']">
<!--                <span v-if="profiles.wechat">{{ lang === 'en' ? 'WeChat' : '微信' }}：{{profiles.wechat}}</span>-->
                <span v-if="profiles.wechat"><i class="profile-icon iconfont iconweixin2"></i>{{ showName(profiles.wechat, '微信', 'WeChat') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.linked_in"><i class="profile-icon iconfont iconlingying"></i>{{showName(profiles.linked_in, '领英', 'LinkedIn') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.homepage"
                      class="not-delimiter"><i class="profile-icon iconfont icongerenwangzhan"></i>{{showName(profiles.homepage, '个人网站', 'WebSite') | hideMessageFormat(hideProfile)}}</span>
              </p>
              <p class="editor-sub-header-title"
                 :class="[formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center' ? 'flex-center' : 'flex-start']">
<!--                <span v-if="profiles.birthday && birthType === 'birthday'">-->
<!--                  {{lang === 'en' ? 'Birthdate' :'生日'}}：{{profiles.birthday}}-->
<!--                </span>-->
                <span v-if="profiles.birthday && birthType === 'birthday'">
                  <i class="profile-icon iconfont iconnianling"></i>{{showName(profiles.birthday, '生日', 'Birthdate') | hideMessageFormat(hideProfile)}}
                </span>
<!--                <span v-if="profiles.Birthday && birthType === 'age'">-->
<!--                  {{lang === 'en' ? 'Age' : '年龄'}}：{{ userAge }}-->
<!--                </span>-->
                <span v-if="profiles.birthday && birthType === 'age'">
                  <i class="profile-icon iconfont iconnianling"></i>{{showName(userAge, '年龄', 'Age') | hideMessageFormat(hideProfile)}}
                </span>
                <span v-if="profiles.gender"><i class="profile-icon iconfont iconxingbie"></i>{{showName(profiles.gender, '性别', 'Gender') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.height"><i class="profile-icon iconfont iconshengao"></i>{{showName(profiles.height, '身高', 'Height') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.weight"><i class="profile-icon iconfont icontizhong"></i>{{showName(profiles.weight, '体重', 'Weight') | hideMessageFormat(hideProfile)}}</span>
<!--                <span v-if="profiles.hometown">{{ lang === 'en' ? 'Hometown' : '籍贯' }}：{{profiles.hometown}}</span>-->
                <span v-if="profiles.hometown"><i class="profile-icon iconfont iconjiguan"></i>{{ showName(profiles.hometown, '籍贯', 'Hometown') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.ethnic"><i class="profile-icon iconfont iconminzu"></i>{{showName(profiles.ethnic, '民族', 'Ethnic') | hideMessageFormat(hideProfile)}}</span>
                <span
                    v-if="profiles.political_status"><i class="profile-icon iconfont iconzhengzhimianmao"></i>{{showName(profiles.political_status, '政治面貌', 'Political Status') | hideMessageFormat(hideProfile)}}</span>
                <span v-if="profiles.marriage"
                      class="not-delimiter"><i class="profile-icon iconfont iconhunyinzhuangkuang"></i>{{showName(profiles.marriage, '婚姻状况', 'Marriage Status') | hideMessageFormat(hideProfile)}}</span>
              </p>
              <p class="editor-sub-header-title"
                 :class="[formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center' ? 'flex-center' : 'flex-start']">
                  <span
                      v-if="profiles.current_job"><i class="profile-icon iconfont icondangqiangongzuozhuangtai"></i>{{showName(profiles.current_job, '当前状态', 'Current Status') | hideMessageFormat(hideProfile)}}</span>
<!--                <span v-if="profiles.exp_job">{{ lang === 'en' ? 'Objective' : '求职意向' }}：{{profiles.exp_job}}</span>-->
                <span v-if="profiles.exp_job"><i class="profile-icon iconfont iconqiuzhiyixiang"></i>{{ showName(profiles.exp_job, '求职意向', 'Objective') | hideMessageFormat(hideProfile)}}</span>
<!--                <span v-if="profiles.expected_salary"-->
<!--                      class="not-delimiter">{{ lang === 'en' ? 'Expected Salary' : '期望薪资' }}：{{profiles.expected_salary}}</span>-->
                <span v-if="profiles.expected_salary"
                      class="not-delimiter"><i class="profile-icon iconfont iconqiwangxinzi"></i>{{ showName(profiles.expected_salary, '期望薪资', 'Expected Salary') | hideMessageFormat(hideProfile)}}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="(formatInfo.head_format === 'center' || formatInfo.head_format === 'body_center') && !hideProfile" class="profile-right avatar">
          <img v-if="formatInfo.head_format === 'center' && profiles.avatar_url" :src="profiles.avatar_url" alt="">
          <img v-if="formatInfo.head_format === 'body_center'" :src="profiles.avatar_url || 'https://files.wondercv.com/pc/cvEditor/cv-default-avatar.png'" alt="">
        </div>
        <div v-else class="profile-right">
          <img v-if="!hideProfile" :src="basicInfo.school_logo_url ? basicInfo.school_logo_url :
                         profiles.avatar_url && !basicInfo.school_logo_url ? profiles.avatar_url : ''" alt="">
        </div>
      </div>
      <template v-for="(item, index) in moduleData">
        <div class="person-info resume-editor-plate" :key="index" v-if="notEmpty(item.type, item.infos)">
          <!-- <div class="title title-text resume-editor-plate-title" :style="{ 'border-bottom-color': formatInfo.theme_color }">
            <span>{{item.title}}</span>
          </div> -->
          <!-- 标题 -->
          <file-cv-title :title="item.title" :formatInfo="formatInfo" :modelType="item.type" />

          <div class="opu-content" v-if="item.type === 'opus'">
            <template v-for="val in item.infos">
              <div :key="val.id" class="opu-item editor-sub-header-title" v-if="item.type === 'opus' && infoNotEmpty(val, item.type)">
                <img :src="val.qrcode" class="qrcode-img">
                <div class="desc" v-if="!val.url">{{val.title}}</div>
                <div class="desc link" v-else><span>{{val.title || `${basicInfo.lang === 'cn' ? '作品链接' : 'portfolio link'}`}}</span></div>
                <!-- <a class="desc link" :href="val.url" target="_blank" v-else><span>{{val.title || `${basicInfo.lang === 'cn' ? '作品链接' : 'portfolio link'}`}}</span></a> -->
              </div>
            </template>
          </div>
          <template v-else>
            <template v-for="val in item.infos">
              <div :key="val.id" class="list-item editor-sub-header-title" v-if="item.type !== 'extras' && infoNotEmpty(val)">
                <info-two-line :info="val" v-if="formatInfo.body_format === 'two_line'"/>
                <info-one-line :info="val" v-if="formatInfo.body_format === 'one_line'" :section="item.type"/>
                <div class="school-tags-container" v-if="val.university && val.show_tags && val.show_tags.length && formatInfo.body_format === 'one_line'">
                  <div class="school-tags-content">
                    <div class="school-tag-item" v-for="itemD in val.show_tags">
                      {{ itemD }}
                    </div>
                  </div>
                </div>
                <div v-html="val.description"></div>
              </div>
              <li :key="val.id" v-if="item.type === 'extras' && val.description" class="plate-item-content editor-sub-header-title">
                <span>{{val.title}}</span>
                <span>{{val.description}}</span>
              </li>
            </template>
          </template>

        </div>
      </template>

    </div>
    <div class="one-page-line" :style="onePageStyle" v-if="showPageLine">
      <span>一页纸</span>
    </div>
    <div class="header-line" v-if="formatInfo.top_format==='line'" :style="{backgroundColor: formatInfo.top_line_color}"></div>
    <img v-if="formatInfo.watermark" :src="`https://files.wondercv.com/pc/watermark/watermark-${formatInfo.watermark}-${formatInfo.page_margin}.png`"  class="watermark" v-show="formatInfo.watermark"/>
  </div>
</template>

<script>
	import { cvMixin } from '../../assets/js/mixin/cv'
	import { mapState } from 'vuex'
	import infoOneLine from './info-one-line'
  import infoTwoLine from './info-two-line'
  import fileCvTitle from './file-cv-title'


	export default {
		name: 'file-cv',
		mixins: [ cvMixin ],
    props: {
			showPageLine: {
				type: Boolean,
        default: true
      }
    },
		data () {
			return {
				cvContentStyle: {},
				onePageStyle: {},
        hideProfile: false
			}
		},
    created () {
		  this.hideProfile = this.$route.query.hideProfile === 'true'
    },
		async mounted () {
			this._initStyle()
		},
		computed: {
			...mapState('cv', [ 'cv', 'profiles', 'moduleData' ]),
			lang () {
				return this.cv.basic_info.lang
			},
      formatInfo () {
        return this.cv.format_info
      },
      basicInfo () {
        return this.cv.basic_info
      }
		},
		watch: {},
		components: {
			infoOneLine,
      infoTwoLine,
      fileCvTitle
		},
		methods: {
			_initStyle () {
				let ratio = parseInt(window.screen.width) * 0.94 / 800
				this.cvContentStyle = {
					'min-height': `${ 304 - parseInt(this.formatInfo.page_margin) * 1.45 }mm`,
					'transform': `scale(${ ratio })`
				}
				this.onePageStyle = {
					top: `${ 297 - parseInt(this.formatInfo.page_margin) * 1.45 }mm`
				}
			},
			showName (val, label_cn, label_en) {
				if (this.profiles.show_attr_name===1) {
					return this.lang === 'cn' ? `${ label_cn }: ${ val }` : `${ label_en }: ${ val }`
				} else {
					return val
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import './styles/file-cv.scss';
  .watermark{
    /*position: absolute;*/
    width: 100%;
    margin-top: 10px;
    /*height: 20px;*/
  }
  .school-tags-container {
    //display: inline-block;
  }

  .school-tags-container .school-tags-content {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .school-tags-container .school-tags-content .school-tag-item {
    padding: 1px 4px;
    background: #E9F1FF;
    border-radius: 3px;
    font-size: 12px;
    font-family: zcoolwenyiti;
    color: #508CFF;
  }
</style>
